<template>
  <!-- Header -->
  <div class="card-header d-flex justify-content-between align-items-center">
    <h4 class="card-header-title mb-0">{{ title }}</h4>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
